import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Grid,
  Paper
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import CustomCard from "../components/CustomCard";
import useSEO from "../hooks/useSEO";

const HISTORY_KEY = "viewedJobs";

const RecentPage = () => {
  useSEO({ title: 'Новые вакансии | JobMD' });
  const [history, setHistory] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    try {
      const raw = localStorage.getItem(HISTORY_KEY) || "[]";
      setHistory(JSON.parse(raw));
    } catch (e) {
      console.error("Ошибка чтения истории:", e);
      setHistory([]);
    }
  }, []);

  return (
    <Box maxWidth="1200px" mx="auto" mt={4} px={2}>

      {/* HEADER */}
      <Box mb={3}>
        <Typography variant="h4" fontWeight="bold">
          Недавно просмотренные
        </Typography>

        <Typography color="text.secondary">
          Вакансии, которые вы недавно открывали
        </Typography>
      </Box>

      {/* CONTENT */}
      {history.length > 0 ? (
        <Grid container spacing={{ xs: 1, md: 3 }}>
          {history.map((job) => (
            <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }} key={job.id}>
              <CustomCard
                id={job.id}
                image={job.image_url || ""}
                title={job.title || ""}
                description={job.description || ""}
                salary={job.salary || ""}
                city={job.city || ""}
                company={job.company || ""}
                dateAdded={job.date_added || ""}
                onMoreClick={() => navigate(`/job/${job.id}`)}
              />
            </Grid>
          ))}
        </Grid>
      ) : (
        <Paper
          sx={{
            p: 4,
            textAlign: "center",
            borderRadius: 3,
          }}
        >
          <Typography color="text.secondary">
            История просмотров пока пустая
          </Typography>
        </Paper>
      )}

    </Box>
  );
};

export default RecentPage;
